module.exports = __webpack_public_path__ + "img/pills.515a2ad6.svg";